module.exports = __webpack_public_path__ + "img/logo-andamanda.0c1e1629.png";